export default __webpack_public_path__ + "static/The Magic of Memory Foam-05455a6445676358d843de75d8884fb2.jpg";